import { Kooi } from "@/types/Kooi/kooi";
import { CreditNoteType, DebitNoteType, GrCommissionOnlyInvoiceClass, GrInvoiceTypeClass, GrOrderTypeClass, InvoiceTypeClass, OrderTypeClass, PurchaseTypeClass, GrPurchaseTypeClass, DiffPurchaseTypeClass } from "./InvoiceTypeClass";

// Einstellungen für das Frontend, hier im allgemeinen die KOOI Settings,
// Rechnungsspezifische Einstellungen wurde begonnen auszulagern in eigene Classen


interface FrontendSettings {
    name : string,
    warn_missing_vat: boolean,
    stock_selection : boolean,
    recipient_selection : boolean,
    customer_selection : boolean,
    supplier_selection : boolean,
    krpo_number : boolean,
    logistic_selection : boolean,
    booking_section : boolean,
    rebate_overwrite : boolean,
    disable_rebates : boolean,
    allow_table_view : boolean,
    adjust_agent_percentage : boolean,
    overwrite_internal_with_supplier_tax: boolean,
    invoice : {
        has_buying_price: boolean,
        has_selling_price: boolean,
        has_buying_tax : boolean,
        has_selling_tax : boolean,
    };
    invoices: {
        order: OrderTypeClass,
        customs: OrderTypeClass,
        Invoice: InvoiceTypeClass,
        proforma: InvoiceTypeClass,
        credit_note?: InvoiceTypeClass,
        debit_note? : InvoiceTypeClass,
    },
    navigationAllowed(kooi? : Kooi) : boolean,
}


export class kooiFrontendSettings implements FrontendSettings{
    name = 'kooiFrontendSettings';
    stock_selection = false;
    warn_missing_vat = true;
    recipient_selection = false;
    customer_selection = false;
    supplier_selection = false;
    krpo_number = false;
    logistic_selection = false;
    booking_section = true;
    rebate_overwrite = false;
    disable_rebates = false;
    allow_table_view = false;
    adjust_agent_percentage = false;
    invoice = {
        has_buying_price: true,
        has_selling_price: true,
        has_buying_tax : false,
        has_selling_tax : false,
    };
    invoices = {
        order: new OrderTypeClass(),
        customs: new OrderTypeClass(),
        Invoice: new InvoiceTypeClass(),
        proforma: new InvoiceTypeClass(),
        credit_note : new CreditNoteType(),
        debit_note : new DebitNoteType(),
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    navigationAllowed(kooi : Kooi) {
        return false;
    }
    overwrite_internal_with_supplier_tax = false;
}



export class stockFrontend extends kooiFrontendSettings {
    name = 'stockFrontend';
    stock_selector = false;
    customer_selection = true;
    supplier_selection = true;
    logistic_selection = true;
    booking_section = true;
    rebate_overwrite = true;
    invoice = {
        has_buying_price: true,
        has_selling_price: true,
        has_buying_tax : true,
        has_selling_tax : true,
    };
    invoices = {
        order: new OrderTypeClass(),
        customs: new OrderTypeClass(),
        Invoice : new InvoiceTypeClass(),
        proforma: new InvoiceTypeClass(),
        debit_note : new DebitNoteType(),
        credit_note : new CreditNoteType(),
        purchase_contract : new PurchaseTypeClass(),
    }
    navigationAllowed(kooi: Kooi) {
        if (kooi &&
            (kooi.sales_type == "stock" || kooi.sales_type == "direct" || kooi.sales_type == "direct_trust") &&
            kooi.data &&
            kooi.data.company &&
            kooi.data.company.id > 0 &&
            kooi.data.company.terms &&
            kooi.data.company.terms.id > 0 &&
            kooi.data.supplier &&
            kooi.data.supplier.id > 0 &&
            kooi.data.supplier.terms &&
            kooi.data.supplier.terms.id > 0
        ) {
            return true;
        }
        return false;
    }
}

export class GrStockFrontend extends kooiFrontendSettings {
    name = 'GrStockFrontend';
    stock_selector = false;
    customer_selection = true;
    supplier_selection = true;
    logistic_selection = true;
    booking_section = true;
    rebate_overwrite = true;
    deliver_to_overwrite = true;
    invoice = {
        has_trust_letter_field: true,
        has_buying_price: true,
        has_selling_price: true,
        has_buying_tax : true,
        has_selling_tax : true,
    };
    invoices = {
        order: new GrOrderTypeClass(),
        customs: new GrOrderTypeClass(),
        Invoice : new GrInvoiceTypeClass(),
        proforma: new GrInvoiceTypeClass(),
        debit_note : new DebitNoteType(),
        credit_note : new CreditNoteType(),
        purchase_contract : new GrPurchaseTypeClass(),
    }
    navigationAllowed(kooi : Kooi) {
        if (kooi &&
            (kooi.sales_type == "stock" || kooi.sales_type == "stock_trust" || kooi.sales_type == "commission_only" || kooi.sales_type == "direct" || kooi.sales_type == "direct_trust") &&
            kooi.data &&
            kooi.data.company &&
            kooi.data.company.id > 0 &&
            kooi.data.company.terms &&
            kooi.data.company.terms.id > 0 &&
            kooi.data.supplier &&
            kooi.data.supplier.id > 0 &&
            kooi.data.supplier.terms &&
            kooi.data.supplier.terms.id > 0
        ) {
            return true;
        }
        return false;
    }
}
export class GrStockTrustFrontend extends GrStockFrontend{

};

export class GrCommissionOnlyFrontend extends GrStockFrontend{
    name = 'GrCommissionOnlyFrontend'
    customer_order_id = true;
    customers = true;
    customer_filter = "";
    invoice = {
        has_trust_letter_field: false,
        has_buying_price: true,
        has_selling_price: true,
        has_buying_tax : true,
        has_selling_tax : true,
    };
    invoices = {
        order: new GrOrderTypeClass(),
        customs: new GrOrderTypeClass(),
        Invoice : new GrCommissionOnlyInvoiceClass(),
        proforma: new GrCommissionOnlyInvoiceClass(),
        debit_note : new DebitNoteType(),
        credit_note : new CreditNoteType(),
        purchase_contract : new PurchaseTypeClass(),
    }
};

export class purchaseFrontend extends kooiFrontendSettings {
    name = 'purchaseFrontend';
    stock_selection = true;
    supplier_selection = true;
    krpo_number = true;
    rebate_overwrite = false;
    logistic_selection = true;
    invoice = {
        has_buying_price: true,
        has_selling_price: false,
        has_buying_tax : true,
        has_selling_tax : false,
    };
    invoices = {
        order: new OrderTypeClass(),
        customs: new OrderTypeClass(),
        Invoice : new InvoiceTypeClass(),
        proforma: new InvoiceTypeClass(),
        debit_note : new DebitNoteType(),
        credit_note : new CreditNoteType(),
        purchase_contract : new PurchaseTypeClass(),
        diff_purchase_contract : new DiffPurchaseTypeClass(),
    };
    allow_table_view = true;
    table_view(){
        const positions =  new purchase_positions_as_table();
        return positions.columns;
    }
    navigationAllowed(kooi : Kooi) {
        if (kooi &&
            kooi.sales_type == "purchase" &&
            kooi.data &&
            kooi.data.company &&
            kooi.data.company.id > 0 &&
            kooi.data.supplier &&
            kooi.data.supplier.id > 0
        ) {
            return true;
        }
        return false;
    }
}

export class directFrontend extends kooiFrontendSettings {
    name = 'directFrontend';
    stock_selector = false;
    customer_selection = true;
    supplier_selection = true;
    logistic_selection = true;
    booking_section = true;
    rebate_overwrite = true;
    adjust_agent_percentage = true;
    invoice = {
        has_buying_price: true,
        has_selling_price: true,
        has_buying_tax : true,
        has_selling_tax : true,
    };
    invoices = {
        order: new OrderTypeClass(),
        customs: new OrderTypeClass(),
        Invoice: new InvoiceTypeClass(),
        proforma: new InvoiceTypeClass(),
        debit_note : new DebitNoteType(),
        credit_note : new CreditNoteType(),
        purchase_contract : new PurchaseTypeClass(),
    }
    navigationAllowed(kooi : Kooi) {
        if (kooi &&
            (kooi.sales_type == "stock" || kooi.sales_type == "direct" || kooi.sales_type == "direct_trust") &&
            kooi.data &&
            kooi.data.company &&
            kooi.data.company.id > 0 &&
            kooi.data.company.terms &&
            kooi.data.company.terms.id > 0 &&
            kooi.data.supplier &&
            kooi.data.supplier.id > 0 &&
            kooi.data.supplier.terms &&
            kooi.data.supplier.terms.id > 0
        ) {
            return true;
        }
        return false;
    }
}

export class GrDirectTrustFrontend extends directFrontend{
    name = 'GrDirectTrustFrontend';
    overwrite_internal_with_supplier_tax = true;
    invoice = {
        has_trust_letter_field: true,
        has_buying_price: true,
        has_selling_price: true,
        has_buying_tax : true,
        has_selling_tax : true,
    };
    invoices = {
        order: new GrOrderTypeClass(),
        customs: new GrOrderTypeClass(),
        Invoice : new GrInvoiceTypeClass(),
        proforma: new GrInvoiceTypeClass(),
        debit_note : new DebitNoteType(),
        credit_note : new CreditNoteType(),
        purchase_contract : new PurchaseTypeClass(),
    }
}

export class GrDirectFrontend extends directFrontend{
    overwrite_internal_with_supplier_tax = true;
    invoices = {
        order: new GrOrderTypeClass(),
        customs: new GrOrderTypeClass(),
        Invoice : new GrInvoiceTypeClass(),
        proforma: new GrInvoiceTypeClass(),
        debit_note : new DebitNoteType(),
        credit_note : new CreditNoteType(),
        purchase_contract : new GrPurchaseTypeClass(),
    }
}

export class provisionFrontend extends kooiFrontendSettings {
    name = 'provisionFrontend';
    recipient_selection = true;
    supplier_selection = false;
    invoice = {
        has_buying_price: false,
        has_selling_price: true,
            has_buying_tax : false,
            has_selling_tax : true,
    };
    navigationAllowed(kooi : Kooi) {
        if (kooi &&
            kooi.sales_type == "provision" &&
            kooi.data &&
            kooi.data.company &&
            kooi.data.company.id > 0 &&
            kooi.data.currency_sell > 0
        ) {
            return true;
        }
        return false;
    }
}
export class rebateFrontend extends kooiFrontendSettings {
    name = 'rebateFrontend';
    stock_selector = false;
    customer_selection = true;
    supplier_selection = false;
    logistic_selection = false;
    booking_section = true;
    rebate_overwrite = false;
    invoice = {
        has_buying_price: false,
        has_selling_price: true,
        has_buying_tax : false,
        has_selling_tax : true,
    };
    disable_rebates = true;
    allow_table_view = false;
    navigationAllowed(kooi : Kooi) {
        if (kooi &&
            kooi.data &&
            kooi.data.company &&
            kooi.data.company.id > 0 &&
            kooi.data.currency_sell > 0
        ) {
            return true;
        }
        return false;
    }
}

export class positions_as_table {
    columns = [
        {
            key: "index",
            label: "pos",
            display: true,
        },
        {
            key: "name",
            label: "name",
            display: true,
            search: "",
        },
        {
            key: "description",
            label: "description",
            display: true,
            search: "",
        },
        {
            key: "quantity",
            label: "quantity",
            display: true,
            search: "",
            type: "decimal",
            digits: 0,
        },
        {
            key: "price",
            label: "price",
            display: true,
            search: "",
            type: "decimal",
            digits: 2,
        },
        {
            key: "total",
            label: "total",
            display: true,
            search: "",
            type: "decimal",
            digits: 2,
        },
    ];
}
export class purchase_positions_as_table {
    columns = [
        {
            key: "index",
            label: "pos",
            display: true,
        },
        {
            key: "name",
            label: "name",
            display: true,
            search: "",
        },
        {
            key: "quantity",
            label: "quantity",
            display: true,
            search: "",
            type: "decimal",
            digits: 3,
        },
        {
            key: "product_number",
            label: "product_number",
            display: true,
            search: "",
        },
        {
            key: "buy_price",
            label: "buy_price",
            display: true,
            search: "",
            type: "decimal",
            digits: 2,
        },
        {
            key: "buying_total",
            label: "buying_total",
            display: true,
            search: "",
            type: "decimal",
            digits: 2,
        },
        {
            key: "shinkiba_reserve.certification",
            label: "certification",
            display: true,
            search: "",
        },
        {
            key: "shinkiba_reserve.degree_of_processing",
            label: "degree_of_processing",
            display: true,
            search: "",
        },
        {
            key: "shinkiba_reserve.dimensionActual",
            label: "dimensionActual",
            display: true,
            search: "",
        },
        {
            key: "shinkiba_reserve.dimensionNominal",
            label: "dimensionNominal",
            display: true,
            search: "",
        },
        {
            key: "shinkiba_reserve.quality",
            label: "quality",
            display: true,
            search: "",
        },
        {
            key: "shinkiba_reserve.specie",
            label: "specie",
            display: true,
            search: "",
        },
        {
            key: "shinkiba_reserve.treatment",
            label: "treatment",
            display: true,
            search: "",
        },
    ];
}
